module.exports = __webpack_public_path__ + "img/51.36313458.svg";